import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useGetOwnerIvideon from "./hooks/useGetOwnerIvideon";
import { Button } from '@pd/pd-ui-kit';

export const LogoutIvideon = ({
  deleteCookie,
  currentDealer,
  getTokenInfo,
  logout,
}: {
  deleteCookie: any;
  currentDealer?: any;
  getTokenInfo?: any;
  logout: boolean;
}) => {
  const [switched, setSwitched] = useState(false);
  const [owner, setOwner] = useState("");
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, isError } = useGetOwnerIvideon(id, switched);

  useEffect(() => {
    if (id && (currentDealer?.access_token || getTokenInfo?.access_token))
      setSwitched(true);
  }, [id, currentDealer, getTokenInfo]);

  useEffect(() => {
    setOwner("");
    if (!isLoading && !isError && data?.dealers[0]?.owner) {
      setOwner(data?.dealers[0]?.owner);
    }
  }, [data, isLoading, isError]);

  return (
    <span
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        alignItems: "end",
      }}
    >
      <span style={{ color: "#495964", fontSize: "16px" }}>{owner}</span>
      {logout && (
        <Button
          onClick={deleteCookie}
          size={'small'}
          color={'success'}
        >
          Выйти из учетной записи IVIDEON
        </Button>
      )}
    </span>
  );
};
